<template>
  <div class="roles-settings">
    <div class="header">
      <h2>🔐 System Roles</h2>
      <button class="btn-add" @click="addRole">+ Add New Role</button>
    </div>

    <table class="roles-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Role Name</th>
          <!-- <th>Description</th> -->
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(role, index) in roles" :key="role.id">
          <td>{{ index + 1 }}</td>
          <td>{{ role.name }}</td>
          <!-- <td>{{ role.description }}</td> -->
          <td>
            <button class="btn-view" @click="viewPermissions(role.id)">
              View Permissions
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <add_role_modal
    @close-add-role-modal="closeAddRole"
    v-if="show_add_role_modal"
  />
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import add_role_modal from "./add_role_modal.vue";
export default {
  name: "SystemRoles",
  data() {
    return {
      show_add_role_modal: false,
      roles: [],
    };
  },
  components: {
    add_role_modal,
  },
  methods: {
    addRole() {
      this.show_add_role_modal = true;
    },
    closeAddRole() {
      this.show_add_role_modal = false;
      this.getRoles();
    },
    viewPermissions(role) {
      this.$router.replace("/role_permissions/" + role);
      //   alert(`Viewing permissions for: ${role.name}`);
    },
    async getRoles() {
      const url = "roles/get";
      const body = {};
      const rs = await generalApiRequest(url, "GET", body, 1);
      this.roles = rs.data;
    },
  },
  mounted() {
    this.getRoles();
  },
};
</script>

<style scoped>
.roles-settings {
  padding: 1.5rem;
  font-family: Arial, sans-serif;
  color: #333;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.header h2 {
  font-size: 1.5rem;
}

.btn-add {
  background: #2786f7;
  color: #fff;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.3rem;
  font-size: 0.9rem;
  cursor: pointer;
}

.roles-table {
  width: 100%;
  border-collapse: collapse;
}

.roles-table th,
.roles-table td {
  border: 1px solid #ddd;
  padding: 0.6rem;
  text-align: center;
  font-size: 0.95rem;
}

.roles-table th {
  background: #f5f5f5;
  font-weight: 600;
}

.roles-table tr:nth-child(even) {
  background: #fafafa;
}

.btn-view {
  background: #2786f7;
  color: #fff;
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.85rem;
}
</style>
